import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table, TableHeader, TableCell } from './styles';
import { selectIsCanadian } from '../../../CommonSelectors/CommonAreaSelector';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

const SOCIAL_SECURITY_ASSUMPTIONS = [
  'SocialSecurityFilingAge',
  'SocialSecurityAmount',
  'SocialSecurityInflationRate',
];

const getAssumptionValue = (assumptionTemplate, assumptionValue) => {
  if (Array.isArray(assumptionValue)) {
    return assumptionValue.map(value => assumptionTemplate(value));
  }
  return [assumptionTemplate(assumptionValue)];
};

const AssumptionsTable = ({ title, valuesList, labelList }) => {
  const isCanadian = useSelector(selectIsCanadian);

  const assumptions = labelList.filter(({ key, dependsOnKey }) => {
    if (isCanadian && SOCIAL_SECURITY_ASSUMPTIONS.includes(key)) {
      return false;
    }

    const hasValidCurrentAssumptionValue = valuesList[key] !== null;
    const hideWhenDependentHasNoValue = dependsOnKey && valuesList[dependsOnKey] === null;

    return hasValidCurrentAssumptionValue && !hideWhenDependentHasNoValue;
  });

  return (
    <Box css="page-break-before: avoid;">
      <Table>
        <thead>
          <tr>
            <th colSpan={2}>
              <Text px={32} py={16} fontSize="h5" textAlign="left" fontWeight="600">
                {title}
              </Text>
            </th>
          </tr>
          <tr>
            <TableHeader>Assumption</TableHeader>
            <TableHeader>Value</TableHeader>
          </tr>
        </thead>

        <tbody>
          {assumptions.map(({ title: assumptionTitle, template, key }, index) => {
            const values = getAssumptionValue(template, valuesList[key]);

            if (values.length === 0) {
              return null;
            }

            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={`${key}-${index}`}>
                <TableCell>{assumptionTitle}</TableCell>
                <TableCell>
                  {values.map((value, valueIndex, array) =>
                    // eslint-disable-next-line react/no-array-index-key
                    array.length === 1 ? value : <div key={valueIndex}>{value}</div>,
                  )}
                </TableCell>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Box>
  );
};

AssumptionsTable.propTypes = {
  title: PropTypes.string.isRequired,
  valuesList: PropTypes.shape({}).isRequired,
  labelList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default AssumptionsTable;
